export default "__VITE_ASSET__0f815c9c__"